export const authRoutes = {
  auth: '/auth',
  login: '/auth/login',
  signup: '/auth/signup',
  signupConfirmation: '/auth/signup/finish',
  resetPassword: '/auth/password',
  signupMobileConfirmation: '/auth/signup/mobile/confirm',
  setNewPassword: '/auth/password/reset',
};
